<template>
  <div>
    <zx-table :tableData="tableData" :option="table" :page="page" :searchDesc="searchDesc" @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange" @delBtn="delBtn" @refresh-change="getlist"
      @refreshBtn="refreshBtn" />

    <ele-form-dialog v-model="formData" :formDesc="formDesc" 
      :request-fn="handleSubmit" 
      :rules="rules"
      labelPosition="left" :form-attrs="{ size: 'small' }" 
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }" 
      :visible.sync="dialogFormVisible" @request-success="handleSuccess" :title="table.title" />
    <!-- 关联分账 -->
    <ele-form-dialog 
    v-model="relevanceFormData" 
    :formDesc="formDescRelevanceFormData" 
    :request-fn="handleSubmitLink"
      :rules="rules" 
      labelPosition="left" :form-attrs="{ size: 'small' }" 
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }" 
      :visible.sync="dialogFormVisibleRelevance" @request-success="handleSuccess" :title="table.subtitle" />
    <el-dialog title="分销二维码" :visible.sync="dialogVisible" width="20%">
      <span>
        <el-tooltip 
        content="鼠标右键选择,'图片另存'为来保存图片" placement="bottom">
          <el-image 
          style="width: 100%; height: 100%" :src="qrUrl" :preview-src-list="[qrUrl]">
          </el-image>
        </el-tooltip>
      </span>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>
<script>
import * as member from "@/api/product/member.js";
import * as routing from "@/api/routing/link.js"
import * as userGroup from "@/api/product/user-group.js";
import * as dept from "@/api/dept/dept.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      searchDesc: {
        nickname: {
          label: "用户名",
          type: "input"
        },
        mobile: {
          label: "手机号",
          type: "input"
        },
        status: {
          label: "状态",
          type: "select",
          options: [
            {
              text: "限制使用",
              value: -1
            },
            {
              text: "正常",
              value: 1
            },
            {
              text: "未提交注册信息",
              value: 2
            },
            {
              text: "待审核注册信息",
              value: 3
            },
            {
              text: "审核失败",
              value: 4
            }
          ]
        }
      },
      formData: {},
      relevanceFormData: {},
      formDescRelevanceFormData: {
        type: {
          label: "账号类型",
          type: "select",
          options: [
            {
              text: "商户",
              value: "MERCHANT_ID"
            },
            {
              text: "个人",
              value: "PERSONAL_OPENID"
            }
          ]
        },
        openid: {
          label: "接收方账号",
          type: "input"
        },
        nickname: {
          label: "接收方名称",
          type: "input"
        },
        is_excess: {
          label: "分账比例",
          type: "input",
          default: "30",
          tip: "分账比例，填30表示30%，分给分账方的金额为订单金额的30%"
        },
        relation_type: {
          label: "与分账方关系",
          type: "select",
          
          options: [
            {
              text: "门店",
              value:"STORE"
            },
            {
              text: "员工",
              value: "STAFF"
            },
            {
              text: "店主",
              value: "STORE_OWNER"
            },
            {
              text: "合作伙伴",
              value: "PARTNER"
            },
            {
              text: "总部",
              value: "HEADQUARTER"
            },
            {
              text: "品牌方",
              value: "BRAND"
            },
            {
              text: "分销商",
              value: "DISTRIBUTOR"
            },
            {
              text: "用户",
              value: "USER"
            },
            {
              text: "供应商",
              value: "SUPPLIER"
            },
            {
              text: "自定义",
              value: "CUSTOM"
            }
          ]
        }
      },
      formDesc: {
        type: {
          label: "账号类型",
          type: "select",
          options: [
           {
            text: "普通用户",
            value: 1
          },
          {
            text: "会员用户",
            value: 2
          },
          {
            text: "分销商用户",
            value: 3
          }
          ]
        },

        // level: {
        //   label: "会员等级",
        //   type: "select",
        //   options: [
        //     {
        //       text: "普通会员",
        //       value: 1
        //     },
        //     {
        //       text: "正式会员",
        //       value: 2
        //     },
        //     {
        //       text: "付费会员",
        //       value: 3
        //     }
        //   ]
        // },
        coding: {
          label: "会员编号(导游编号)",
          type: "input"
        },
        name: {
          label: "用户名",
          type: "input"
        },
        mobile: {
          label: "手机号",
          type: "input"
        },
        idcard: {
          label: "身份号",
          type: "input"
        },
        group_id: {
          label: "所属分组",
          type: "select",
          options: userGroup.deleteUserGroupAll.r(),
          hide: true
        },
        dept_id: {
          label: "所属部门",
          type: "select",
          show: "tag",
          prop: {
            text: "label",
            value: "id"
          },
          options: dept.getDeptTree.r(),
          hide: true
        }
        // status: {
        //   label: "状态",
        //   type: "input"
        // },
      },
      rules: {},
      qrUrl: "",
      dialogVisible: false,
      dialogFormVisible: false,
      dialogFormVisibleRelevance: false,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "会员",
        subtitle:"关联分账",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "nickname",
            label: "用户名",
            show: "hyperlinks",
            size: "small",
            type: "primary",
            click: (id, row, index) => {
              this.$router.push({
                path: "/product/member/info/" + row.member_id,
                query: { id: row.member_id }
              });
            },
            hide: true
          },
          {
            prop: "name",
            label: "名称",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            hide: true
          },
          {
            prop: "mobile",
            label: "用户手机号",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            hide: true
          },
          {
            prop: "group_id",
            label: "所属分组",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            show: "tag",
            tagtype:[],
            hide: true
          },
          {
            prop: "dept_id",
            label: "所属部门",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            show: "tag",
            tagtype: [],
            hide: true
          },
          {
            prop: "balance",
            label: "余额",
            hide: true
          },
          {
            prop: "type",
            label: "账号类型",
            type: "input",
            show: "tag",
            // 1普通用户 2会员用户 3分销商用户
            tagtype: [
            {
            text: "普通用户",
            value: 1
          },
          {
            text: "会员用户",
            value: 2
          },
          {
            text: "分销商用户",
            value: 3
          }
            ],
            hide: true
          },
          {
            prop: "status",
            label: "用户状态",
            type: "input",
            show: "tag",
            // 1普通会员 2正式会员 3付费会员
            tagtype: [
              {
                text: "限制使用",
                value: -1
              },
              {
                text: "正常",
                value: 1
              },
              {
                text: "未提交注册信息",
                value: 2
              },
              {
                text: "待审核注册信息",
                value: 3
              },
              {
                text: "审核失败",
                value: 4
              }
            ],
            hide: true
          },
          {
            prop: "create_time",
            label: "创建时间"
          }
        ],
        btnList: [
          {
            name: "分销二维码",
            size: "mini",
            type: "text",
            Vif: e => {
              return e.status != 2;
            },
            click: (id, row, index) => {
              member.getMemberShareQr.r({ id: row.member_id }).then(res => {
                this.qrUrl = res.url;
                this.dialogVisible = true;
              });
            }
          },
          {
            name: "编辑",
            size: "mini",
            type: "text",
            Vif: e => {
              return e.status != 2;
            },
            click: (id, row, index) => {
              this.formData = row;
              this.dialogFormVisible = true;
            }
          },
          {
            name: "关联分账",
            size: "mini",
            type: "text",
            Vif: e => {
              return e.status == 1 && e.is_routing == 0;
            },
            click: (id, row, index) => {
              this.relevanceFormData = row;
              this.dialogFormVisibleRelevance = true;
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  mounted() {
    // userGroup.deleteUserGroupAll.r().then(res => {
    //   console.log("所属分组".res);
    // }),
    // dept.getDeptTree.r().then(res => {
    //   this.formDesc.dept_id["options"] = res.parent_id;
    //   console.log(res);
    // })
  },
  methods: {
    downloadIamge(imgsrc, name) {
      // let that = this
      // //下载图片地址和图片名
      // var image = new Image();
      // // 解决跨域 Canvas 污染问题
      // image.setAttribute("crossOrigin", "anonymous");
      // image.crossOrigin = '';
      // image.onload = function() {
      //   var canvas = document.createElement("canvas");
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   var context = canvas.getContext("2d");
      //   context.drawImage(image, 0, 0, image.width, image.height);
      //   var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

      //   var a = document.createElement("a"); // 生成一个a元素
      //   var event = new MouseEvent("click"); // 创建一个单击事件
      //   a.download = name || "photo"; // 设置图片名称
      //   a.href = url; // 将生成的URL设置为a.href属性
      //   a.dispatchEvent(event); // 触发a的单击事件
      // };
      // image.src = imgsrc;
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    handleSubmit(form) {
      member.editMember.r(form).then(res => {
        this.chushihua("编辑成功");
      });
    },
    handleSubmitLink(form){
      form.account = form.openid
      this.$confirm("是否关联, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        routing.routingLink.r(form).then(res => {
          this.chushihua("关联成功");
          this.dialogFormVisibleRelevance = false
        }).catch((err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "已取消关联"
          });
        });
      })
    },
    chushihua(text) {
      if (text) this.$message.success(text);
      this.formData = {};
      this.dialogFormVisible = false;
      this.getlist();
    },
    handleSuccess() {
      
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          member.deleteMember.r({ member_id: form.member_id }).then(res => {
            console.log("成功");
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      member.getMemberList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
        console.log( that.tableData,"数据列表");
      });
    }
  }
};
</script>
